import { gql } from '@reverbdotcom/commons/src/gql';
import {
  Core_Marketplace_Remixer_SearchQuery,
} from '@reverbdotcom/commons/src/gql/graphql';

export function v0Input(url) {
  const urlSearchParams = new URLSearchParams(url.search);
  return {
    query: urlSearchParams.get('query') || '',
    page: parseInt(urlSearchParams.get('page'), 10) || 1,
    pageSize: 45,
    currentSearchParams: urlSearchParams.toString(),
  };
}

export type SearchRemixer_MarketplaceListingsSearch = Core_Marketplace_Remixer_SearchQuery['marketplaceListingsSearch'];

export const SearchRemixer_FacetFields = gql(`
  fragment SearchRemixer_FacetFields on SearchResultFacet {
    all
    key
    count
    displayName
    paramValue
    searchUrl
    selected
    subFacets {
      all
      key
      count
      displayName
      paramValue
      searchUrl
      selected
      subFacets {
        all
        key
        count
        displayName
        paramValue
        searchUrl
        selected
      }
    }
  }
`);

export const SearchRemixer_FacetGroupFields = gql(`
  fragment SearchRemixer_FacetGroupFields on SearchResultFacetGroup {
    all
    displayName
    key
    featured
    widgetType
    facets {
      ...SearchRemixer_FacetFields
    }
  }
`);

export const SearchRemixer_SortFields = gql(`
  fragment SearchRemixer_SortFields on Sorts {
    displayText
    key
    sortOptions {
      displayName
      slug
      key
      selected
      searchUrl
    }
    widgetType
  }
`);

export const SearchRemixer_QueryInfoFields = gql(`
  fragment SearchRemixer_QueryInfoFields on SearchQueryInfo {
    originalQuery
    executedQuery
    rewritten
    showOriginalQueryLink
    spellCorrected
    displayInfo {
      rewriteStrategy
      displayMessage
    }
  }
`);

export const MARKETPLACE_REMIXER_SEARCH = gql(`
  query Core_Marketplace_Remixer_Search(
    $input: MarketplaceSearchInput!
  ) {
    marketplaceListingsSearch(input: $input) {
      query
      adjustedSearchUrl
      pagination {
        total
        page
        pageSize
      }
      sorts {
        ...SearchRemixer_SortFields
      }
      facetInfo {
        facetGroups {
          ...SearchRemixer_FacetGroupFields
        }
      }
      results {
        score
      }
      listings {
        _id
        bumpKey {
          key
        }
        ...ListingCardFields
      }
      promotionInfo {
        promotionType
      }
      queryInfo {
        ...SearchRemixer_QueryInfoFields
      }
    }
  }
`);
